import { render, staticRenderFns } from "./app-message-dialog.vue?vue&type=template&id=0bb67344&scoped=true&"
import script from "./app-message-dialog.vue?vue&type=script&lang=js&"
export * from "./app-message-dialog.vue?vue&type=script&lang=js&"
import style0 from "./app-message-dialog.vue?vue&type=style&index=0&id=0bb67344&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb67344",
  null
  
)

export default component.exports